<div class="brand-label">
  <div class="left-side">
    <img
      *ngIf="data | getVariantAssetForCard | async as variantAsset"
      appImage
      class="brand-logo"
      [asset]="variantAsset"
      src=""
      alt="" />
    <div class="wrapper">
      <div class="classification-letter" [style.background-color]="viewModel.strainTypeColor$ | async">
        {{ viewModel.strainTypeSymbol$ | async }}
      </div>
      <img
        *ngIf="viewModel.labelAssetUrl$ | async as labelAssetUrl"
        class="product-image"
        [src]="labelAssetUrl"
        alt="product image" />
    </div>
    <div
      *ngIf="viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) | async as size"
      class="product-size">
      {{ size }}
    </div>
  </div>
  <div class="splitter" [style.background-color]="viewModel.strainTypeColor$ | async"></div>
  <div class="right-side">
    <div
      *ngIf="viewModel.labelData$ | async | sectionRowViewModelBasicMethod: 'getRowTitle' as name"
      class="product-name">
      {{ name }}
    </div>
  </div>
</div>
